import styles from './BottomMenuBar.module.css';
import { LFC } from '../../types';
import clsx from 'clsx';

interface BottomMenuBarProps {
  hidden?: boolean;
}

export const BottomMenuBar: LFC<BottomMenuBarProps> = ({
  children,
  hidden,
}) => {
  return (
    <div className={clsx(styles.bottomMenuBar, hidden && styles.hidden)}>
      {children}
    </div>
  );
};
